// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UaG6","left":"styles_left__2vSKE"};